import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';

import FabricSubCategory from '@components/commonFilters/materials/Fabrics/FabricSubCategory';
import CustomDropdown from '@components/CustomDropdown';
import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';
import AddNewFabricType from '@components/materials/AddNewFabricType';

import { fetchMaterials, fetchProductMaterials } from '@store/design/action';

import ApiClient from '@lib/apiClient';

import {
	compositionCalculation,
	compositionDefaultFieldSet,
	fetchCompositionNameList,
	getFabricCategory,
	getFabricTypeName,
	onChangeCompositionPercentage,
	onChangeCompositionSelection
} from '@utils/MaterialsUtil';
import { _getKey, capitalizeFirstLetter, checkAnyUserType, validateFloatNumber } from '@utils/Util';

const AddFabric = ({ isShow, onCloseModal, onItemClick, productId, onSelectItem, isMainFabric = true }) => {
	const [compositionNameList, setCompositionNameList] = useState([]);
	const [compositionFieldInfoList, setCompositionFieldInfoList] = useState(
		compositionDefaultFieldSet(2, [])
	);
	const [fabricSpec] = useState([]);
	const [fabricBase, setFabricBase] = useState('');
	const [gsm, setGsm] = useState(null);
	const [fabricConstruction, setFabricConstruction] = useState({});
	const [description, setDeescription] = useState('');
	const [yarnCount] = useState('');
	const [documentId] = useState(null);
	const [isModalLoading, setIsModalLoading] = useState(false);
	const [errors, setErrors] = useState({});
	const [errors2, setErrors2] = useState({});
	const [isFabricTypeModify, setIsFabricTypeModify] = useState(false);
	const [isAddNew, setIsAddNew] = useState(false);
	const [addNewValue, setAddNewValue] = useState('');
	const [fabricTypeList, setFabricTypeList] = useState([]);
	const [fabricTypeResponse, setFabricTypeResponse] = useState([]);
	const [selectedFabricTypeToEdit, setSelectedFabricTypeToEdit] = useState(null);

	const dispatch = useDispatch();

	const renderErrorInfo = () => {
		setErrors({
			fabricCategoryError: '',
			fabricSubCategoryError: '',
			fabricCompositionError: ''
		});
	};

	useEffect(() => {
		fetchCompositionNameList(setCompositionNameList).finally();
	}, []);

	const onSubmit = async () => {
		let compositionCalObj = compositionCalculation(compositionFieldInfoList);

		if (compositionCalObj.percentageIsNotOk) {
			setErrors({ ...errors, compositionError: 'Total composition needs to be 100%' });
			return false;
		} else if (compositionCalObj.fiberNameIsNotOk) {
			setErrors({ ...errors, compositionError: 'Select composition' });
			return false;
		} else {
			setErrors(delete errors.compositionError);
			compositionPartChecking(compositionCalObj.compositionPart).finally(() => {});
		}
	};

	const fabricAdd = async (compositionPartIdList) => {
		if (JSON.stringify(fabricConstruction) === '{}') {
			setErrors2({ ...errors2, fabricSubCategoryError: 'Fabric type is required' });
			return;
		} else {
			setErrors2({ ...errors2, fabricSubCategoryError: undefined });
		}
		if (compositionPartIdList.length === 0) {
			setErrors({ ...errors, compositionError: 'Fabric composition is required' });
			return;
		}
		if (gsm === null || gsm === undefined || gsm.toString().trim() === '') {
			setErrors2({ ...errors2, weightError: 'Weight is required' });
			return;
		} else {
			setErrors2({ ...errors2, weightError: undefined });
		}

		const fabricData = {
			construction: fabricConstruction.id,
			fabricCompositionPartIdList: [...compositionPartIdList],
			tagRequestList: [...fabricSpec],
			description,
			documentId,
			gsm,
			fabricBase,
			materialType: isMainFabric ? 'MAIN_FABRIC' : 'EXTRA_FABRIC',
			yarnCount
		};

		if (documentId) {
			fabricData.documentIdList = [documentId];
		}
		if (productId) {
			fabricData.productId = productId;
		}
		setIsModalLoading(true);
		await ApiClient.POST('addFabric', fabricData)
			.then(({ data }) => {
				setIsModalLoading(false);
				if (data.success) {
					toastSuccess(data.message);
					if (onItemClick) {
						onItemClick(
							(data = {
								title: 'Fabric',
								id: data.id,
								value: data?.payload?.name
							})
						);
					}
					if (onSelectItem) {
						onSelectItem((data = { id: data.id, value: data.payload.name }));
					}
					dispatch(fetchMaterials());
					if (productId) {
						dispatch(fetchProductMaterials(productId));
					}
					onCloseModal();
				} else {
					toastError(data.message);
				}
			})
			.catch(({ response }) => {
				setIsModalLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
		renderErrorInfo();
	};

	const compositionPartChecking = async (selected) => {
		if (selected)
			await ApiClient.GET('getCompositionParts', `?compositionDetails=` + encodeURIComponent(selected))
				.then(({ data }) => {
					if (data.length === 0) {
						setErrors({ ...errors, compositionError: 'Composition is wrong' });
					} else {
						setErrors({ ...errors, compositionError: undefined });
						fabricAdd(data);
					}
				})
				.catch(({ response }) => {
					if (response && response.data && response.data.message) {
						toastError(response.data.message);
						setErrors({ ...errors, compositionError: 'Composition is wrong' });
					} else {
						setErrors({ ...errors, compositionError: 'Composition is wrong' });
					}
				});
	};
	const onAddNew = (value) => {
		setAddNewValue(value);
		getFabricCategory(setIsAddNew, setFabricTypeList);
	};
	const setNewFabricType = ({ data }) => {
		if (!data) {
			return;
		}
		setSelectedFabricTypeToEdit({ ...data });
		setFabricConstruction({
			id: data?.id,
			value: `${getFabricTypeName(data?.fabricType)?.name}-${data?.name}`,
			fabricType: data?.fabricType,
			name: data?.name
		});

		setIsFabricTypeModify(true);
	};
	const compositionRender = (obj, index) => {
		return (
			<div className="col-md-6" key={_getKey()}>
				<div className="form-group composition-item mb-0">
					<div className="d-flex">
						<input
							type="number"
							// pattern={'[0-9]+(.[0-9]{1,2})?'}
							defaultValue={obj?.percentage}
							min={0.1}
							max={100}
							onBlur={(e) =>
								onChangeCompositionPercentage(
									e.target.value,
									index,
									compositionFieldInfoList,
									setCompositionFieldInfoList
								)
							}
							className="input-percentage"
						/>
						<p className="percentage">%</p>
						<div className="select-component">
							<div className="form-group">
								<CustomDropdown
									type="fabricName"
									title={'Composition'}
									toolTipLength={18}
									onItemClick={(value) =>
										onChangeCompositionSelection(
											value,
											index,
											compositionFieldInfoList,
											setCompositionFieldInfoList
										)
									}
									items={compositionNameList}
									selectedItem={obj?.fiberName}
									searchPlaceholder="Composition"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	return (
		<LoaderComponent loading={isModalLoading}>
			<Modal show={isShow} onHide={onCloseModal} backdrop="static" centered size="lg">
				<div className="add-new-popup new-fabric-popup">
					<Modal.Header closeButton>
						<h3 className="semibold-16">Add new fabric</h3>
					</Modal.Header>
					<Modal.Body>
						<section>
							<div className="popup-body">
								<div className="row">
									<div className="col-md-12 pl-1">
										<div className="row">
											<div className="col-md-12">
												<div className="form-group fabric-sub-category select-component">
													<label htmlFor="fabricType">Fabric type*</label>
													<FabricSubCategory
														onSelectCallBack={(value) =>
															setFabricConstruction(value)
														}
														type={'INPUT'}
														isEditable={true}
														isAddNew={checkAnyUserType([
															'ADMIN',
															'INVENTORY_MANAGEMENT',
															'MATERIAL_MANAGEMENT'
														])}
														previousValue={
															selectedFabricTypeToEdit &&
															`${capitalizeFirstLetter(
																`${selectedFabricTypeToEdit?.fabricType} - ${selectedFabricTypeToEdit?.groupName} - ${selectedFabricTypeToEdit?.name}`
															)}`
														}
														onAddNew={onAddNew}
														isFabricTypeModify={isFabricTypeModify}
														fabricTypeList={fabricTypeResponse}
														setFabricTypeList={setFabricTypeResponse}
													/>
													{errors2?.fabricSubCategoryError && (
														<p className="error">
															{errors2?.fabricSubCategoryError}
														</p>
													)}
													{isAddNew && (
														<AddNewFabricType
															fabricTypeList={fabricTypeList}
															setIsAddNew={setIsAddNew}
															addNewValue={addNewValue}
															setNewFabricType={setNewFabricType}
															setIsLoading={setIsModalLoading}
															selectedFabricTypeToEdit={
																selectedFabricTypeToEdit
															}
															setSelectedFabricTypeToEdit={
																setSelectedFabricTypeToEdit
															}
														/>
													)}
												</div>
											</div>

											<div className="col-md-12">
												<div className="form-group mb-3">
													<label htmlFor="style-title">Weight*</label>
													<input
														type="number"
														name="style-title"
														onKeyPress={validateFloatNumber}
														id="style-title"
														onChange={(e) => setGsm(e.target.value)}
													/>

													{errors2?.weightError && (
														<p className="error">{errors2?.weightError}</p>
													)}
												</div>
											</div>
											<div className="col-md-12">
												<label htmlFor>Composition</label>
											</div>
											<div className="col-md-12 compositions-list">
												<div className="row">
													{compositionFieldInfoList?.map((obj, index) =>
														compositionRender(obj, index)
													)}
												</div>
												<div className="col-md-12 compositonError">
													{errors?.compositionError && (
														<p className="error">{errors.compositionError}</p>
													)}
												</div>
											</div>
											{/*<div className="col-md-12">*/}
											{/*	<div className="form-group no-shadow-react-select size36">*/}
											{/*		<label htmlFor="Composition1">Composition*</label>*/}
											{/*		<CreatableSelect*/}
											{/*			isClearable*/}
											{/*			value={fabricCompositionPart}*/}
											{/*			onChange={onChangeComposition}*/}
											{/*			options={compositionList}*/}
											{/*			onInputChange={(value) =>*/}
											{/*				searchCompositionsValue(value)*/}
											{/*			}*/}
											{/*		/>*/}
											{/*		*/}
											{/*		{errors?.compositionError && (*/}
											{/*			<p className="error">{errors.compositionError}</p>*/}
											{/*		)}*/}
											{/*	</div>*/}
											{/*</div>*/}

											<div className="col-md-12">
												<div className="form-group ">
													<label htmlFor="fabricBase">Fabric base</label>
													<select
														className="w-100"
														name="fabricBase"
														id="fabricBase"
														value={fabricBase}
														onChange={(e) => setFabricBase(e.target.value)}
													>
														<option value={''}>Select</option>
														<option value="PREMIUM">Premium</option>
														<option value="SEASONAL">Seasonal</option>
														<option value="CORE">Core</option>
														<option value="REGULAR">Regular</option>
													</select>
												</div>
											</div>
											<div className="col-md-12">
												<div className="form-group mb-3">
													<label htmlFor="style-title">Remarks</label>
													<textarea
														placeholder="Write remarks"
														name="style-title"
														id="style-title"
														onChange={(e) => setDeescription(e.target.value)}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</Modal.Body>
					<Modal.Footer>
						<div className="popup-footer">
							<div className="buttons text-right">
								<button className="button gray-outline size32" onClick={onCloseModal}>
									Cancel
								</button>
								<button
									className="button size32"
									onClick={onSubmit}
									disabled={isModalLoading}
								>
									Submit{' '}
								</button>
							</div>
						</div>
					</Modal.Footer>
				</div>
			</Modal>
		</LoaderComponent>
	);
};

export default AddFabric;
